exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Products{width:90%;margin:0 auto}.Products .table{width:100%}.Products .table .sorting{background-image:url(\"/images/sort_both.png\");background-repeat:no-repeat;background-position:100%}.Products .table .sorting_asc{background-image:url(\"/images/sort_asc.png\");background-repeat:no-repeat;background-position:100%}.Products .table .sorting_desc{background-image:url(\"/images/sort_desc.png\");background-repeat:no-repeat;background-position:100%}h1{text-align:center;font-size:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-690d660f","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/Item/Others.vue
// module id = LP8y
// module chunks = 0